import { createAsyncThunk } from '@reduxjs/toolkit'
import metricService from 'services/metric/metric.service'

export const getUserMetrics = createAsyncThunk(
	'metric/user/get',
	metricService.getUserMetrics
)
